import { TennisRatingSystem, TennisSystemDefinition } from './types';

export const TENNIS_SYSTEMS: Record<TennisRatingSystem, TennisSystemDefinition> = {
  utr: {
    id: 'utr',
    shortName: 'UTR',
    longName: 'Universal Tennis Rating',
    scaleMin: 1.0,
    scaleMax: 16.5,
    step: 0.01,
    websiteUrl: 'https://www.utrsports.net',
    websiteLabel: 'utrsports.net',
    oneLineDescription:
      'Algorithmic rating from match results on a 1–16.5 scale. The de facto global standard for adult, junior, and college tennis. Used by ITA, ATP-affiliated events, and most US junior tournaments.',
    whereToFind: 'Sign in to your UTR Sports profile at utrsports.net.',
  },
  ntrp: {
    id: 'ntrp',
    shortName: 'NTRP',
    longName: 'USTA National Tennis Rating Program',
    scaleMin: 1.0,
    scaleMax: 7.0,
    step: 0.5,
    websiteUrl: 'https://www.usta.com/en/home/play/adult-tennis/programs/national/about-ntrp.html',
    websiteLabel: 'usta.com/ntrp',
    oneLineDescription:
      'USTA’s 1.0–7.0 rating in 0.5 steps. The standard US tennis rating — used by USTA leagues and adult tournaments for skill-level brackets.',
    whereToFind: 'Check your USTA player profile, or use your league/tournament results.',
  },
  dynamic_ntrp: {
    id: 'dynamic_ntrp',
    shortName: 'Dynamic NTRP',
    longName: 'USTA Computer (Dynamic) NTRP',
    scaleMin: 1.0,
    scaleMax: 7.0,
    step: 0.001,
    websiteUrl:
      'https://www.usta.com/en/home/play/adult-tennis/programs/national/ntrp-and-the-rating-system.html',
    websiteLabel: 'usta.com',
    oneLineDescription:
      'The 3-decimal computer-calculated version of NTRP that USTA computes from league match results. Drives end-of-year ratings and league promotion/relegation.',
    whereToFind: 'Released by USTA each November in your account profile.',
  },
  wtn: {
    id: 'wtn',
    shortName: 'WTN',
    longName: 'World Tennis Number',
    scaleMin: 1.0,
    scaleMax: 40.0,
    step: 0.1,
    isInverted: true,
    websiteUrl: 'https://worldtennisnumber.com',
    websiteLabel: 'worldtennisnumber.com',
    oneLineDescription:
      'The ITF’s official global rating, launched 2022. Lower number = stronger player. Scale runs ~40 (beginner) down to 1 (pro). Federation-backed in 100+ countries.',
    whereToFind: 'Sign in at worldtennisnumber.com or via your national federation profile.',
  },
  itn: {
    id: 'itn',
    shortName: 'ITN',
    longName: 'ITF Tennis Number (legacy)',
    scaleMin: 1.0,
    scaleMax: 10.3,
    step: 0.1,
    isInverted: true,
    websiteUrl: 'https://www.itftennis.com',
    websiteLabel: 'itftennis.com',
    oneLineDescription:
      'The ITF’s previous global rating, replaced by WTN in 2022. Scale runs 10.3 (just learning) down to 1 (world-class). Still surfaces in some federation profiles.',
    whereToFind:
      'Old federation profiles or club records — new ITF-aligned ratings now publish as WTN.',
    isLegacy: true,
  },
  self_rated: {
    id: 'self_rated',
    shortName: 'Self-Rated',
    longName: 'USTA NTRP Self-Rating',
    scaleMin: 1.0,
    scaleMax: 7.0,
    step: 0.5,
    websiteUrl:
      'https://www.usta.com/en/home/play/adult-tennis/programs/national/ntrp-self-rate.html',
    websiteLabel: 'usta.com',
    oneLineDescription:
      'Honor-system NTRP self-rating using USTA’s 1.0–7.0 guidelines. The starting point before you have league results, and the most common rating recreational players know.',
    whereToFind: 'Use the descriptions on this page or take USTA’s self-rate guide.',
  },
};

export const ALL_TENNIS_SYSTEM_IDS: TennisRatingSystem[] = [
  'utr',
  'ntrp',
  'dynamic_ntrp',
  'wtn',
  'itn',
  'self_rated',
];

export const PRIMARY_TENNIS_SYSTEM_IDS: TennisRatingSystem[] = [
  'utr',
  'ntrp',
  'wtn',
  'dynamic_ntrp',
  'itn',
  'self_rated',
];
